import appConfigJson from '../config/app-config.json';
import type { AppConfig } from '../types/appConfig';
const appConfig = appConfigJson as AppConfig;
export interface CaptureContextResponse {
  captureContextJwtToken: string;
  decodedHeader?: unknown;
  decodedPayload?: unknown;
  rawJwtMode?: boolean;
  correlationId?: string;
}

// Allowed country codes for capture-context request
export type CountryCode = 'USA' | 'CAN';

export interface CaptureContextRequest {
  country: CountryCode;
}

function deriveCountry(explicit?: string): CountryCode | undefined {
  const src = (explicit || '').trim().toUpperCase();
  if (!src) return undefined;
  if (['US','USA','UNITED STATES','UNITEDSTATES'].includes(src)) return 'USA';
  if (['CA','CAN','CANADA'].includes(src)) return 'CAN';
  return undefined; // invalid
}

// Fetch capture context
export async function fetchCaptureContext(countryParam?: string, jwtToken?: string): Promise<CaptureContextResponse> {
  const endpoint = appConfig.captureContextUrl || '';
  // Derive country precedence: explicit arg > URL query param
  let country = deriveCountry(countryParam);
  if (!country && typeof window !== 'undefined') {
    try {
      const qp = new URLSearchParams(window.location.search);
      country = deriveCountry(qp.get('Country') || qp.get('country') || undefined);
    } catch {/* ignore */}
  }
  if (!country) {
    throw new Error('Country required (expected USA or CAN)');
  }
  const body: CaptureContextRequest = { country };
  const headers: Record<string, string> = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };
  if (jwtToken) {
    headers['Authorization'] = `Bearer ${jwtToken}`;
  }
  const res = await fetch(endpoint, {
    method: 'POST',
    headers,
    body: JSON.stringify(body)
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Failed to fetch capture context: ${res.status} ${text}`);
  }
  return res.json();
}
